/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Whyh_HInputs */

const en_wc_whyh_h = /** @type {(inputs: Wc_Whyh_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore what WordCraft can do`)
};

/**
* | output |
* | --- |
* | "Explore what WordCraft can do" |
*
* @param {Wc_Whyh_HInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_whyh_h = /** @type {((inputs?: Wc_Whyh_HInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Whyh_HInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_whyh_h(inputs)
});
export { wc_whyh_h as "wc.whyh.h" }